import React from "react";
import { useI18n } from "../contexts/I18nContext";
import { SITE, buildWhatsAppLink } from "../data/static";

const WhatsAppIcon = ({ className = "w-7 h-7" }) => (
  <svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" className={className}>
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.4-.545-.484-1.064-1.04-1.474-1.642-.255-.378-.13-.578.137-.91.155-.192.4-.41.582-.66.114-.176.155-.314.234-.524.058-.155.026-.295-.053-.46-.078-.166-.728-1.79-.997-2.345-.137-.27-.255-.323-.487-.323-.107 0-.214-.013-.32-.013-.18 0-.474.027-.717.27-.295.32-1.13 1.107-1.13 2.7 0 1.59 1.16 3.135 1.32 3.35.158.217 2.244 3.41 5.486 4.66 2.6 1.022 3.12.83 3.69.776.567-.055 1.812-.733 2.07-1.45.255-.715.255-1.33.18-1.45-.07-.12-.27-.193-.53-.32M16 7c-4.973 0-9 4.027-9 9 0 1.713.487 3.32 1.323 4.674L7 25l4.6-1.21A8.9 8.9 0 0 0 16 25c4.973 0 9-4.027 9-9s-4.027-9-9-9m0-2C22.075 5 27 9.925 27 16c0 6.075-4.925 11-11 11a10.94 10.94 0 0 1-5.16-1.28L4 28l2.31-7.18A10.94 10.94 0 0 1 5 16C5 9.925 9.925 5 16 5" />
  </svg>
);

export const WhatsAppWidget = () => {
  const { t } = useI18n();
  const link = buildWhatsAppLink(t.widget.waMsg);

  return (
    <a href={link} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float" aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 group">
      <span className="relative inline-flex items-center gap-2 sm:gap-3 pl-3 sm:pl-4 pr-4 sm:pr-5 py-3 rounded-full bg-[#22c55e] hover:bg-[#16a34a] text-white shadow-2xl shadow-emerald-500/30 transition-all duration-300 active:scale-95">
        <span className="relative w-10 h-10 rounded-full bg-white/15 flex items-center justify-center animate-pulse-ring">
          <WhatsAppIcon className="w-6 h-6" />
        </span>
        <span className="hidden sm:flex flex-col leading-tight">
          <span className="text-[10px] uppercase tracking-wider opacity-90">{t.widget.eyebrow}</span>
          <span className="text-sm font-semibold">{SITE.phoneDisplay}</span>
        </span>
      </span>
    </a>
  );
};

export default WhatsAppWidget;
